<div
  *ngIf="iframe"
  class="mobile-promotion mobile-news-item"
  [innerHTML]="iframe"
></div>
